import React from "react";
import quizImageMap from "../../pages/story-quiz/quizImages";
import defaultImage from "../../images/rating.png";

import "./styles.scss";

function QuizComplete({ answerMap, recommendations }) {
  let topRecommendation = GetTopRecommendation(recommendations);

  return (
    <section className="hero is-light is-fullheight is-bold white-background">
      <div className="hero-body">
        <div className="container">
          <div className="Features__columns columns is-variable is-8 is-vcentered has-text-centered-mobile">
            <div className="column is-half">
              <figure className="Features__image image">
                <img src={quizImageMap[topRecommendation] ? quizImageMap[topRecommendation.image] : defaultImage} alt="rating" />

              </figure>
            </div>
            <div className="column is-half">
              <h1 className="title">
                Your #1 zero-waste impact action:
              </h1>
              <h1 className="title green">
                {topRecommendation ? topRecommendation.title : "You’re a super star!"}
              </h1>
          <p>{topRecommendation ? topRecommendation.text : "Keep doing what you’re doing. You’re setting an amazing example."}</p>
            </div>
          </div>
          <div className="column">
            {recommendations.length > 1 ? (
              <RecommendationList recommendations={recommendations} />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}

function GetTopRecommendation( recommendations ) {
  return recommendations.sort((a, b) => a.rank > b.rank)[0];
}

function RecommendationList({ recommendations }) {
  recommendations.shift();

  return (
    <div className="RecommendationList__container">
      <ol type="1">
      <div className="container">
          <div className="accordion">
            <div className="option">
              <input type="checkbox" id="toggle1" className="toggle" />
              <label className="title-accordion" htmlFor="toggle1">Want to do more? <span style={{ color: "#3DCC92" }}>Click here</span> to discover what else you can do to be less less wasteful.</label>
              <div className="content">
                {recommendations.map(x => (
                  <ul>
                    <li><span style={{ fontWeight: 700, color: "#3DCC92" }}>{x.title}</span> {x.text}</li>
                  </ul>
                ))}{" "}
              </div>
            </div>
          </div>
        </div>
      </ol>
    </div>
  );
}

export default QuizComplete;
